"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.OptionUnitSchema = void 0;
const yup_1 = require("yup");
const constants_1 = require("../constants");
exports.OptionUnitSchema = (0, yup_1.object)({
    companyId: (0, yup_1.string)().label("Company ID").required(),
    optiongrantId: (0, yup_1.string)().label("Option Grant ID").required(),
    numberGranted: (0, yup_1.number)().label("Number granted").required().min(0),
    vestingDate: (0, yup_1.date)().label("Vesting date").required().typeError(constants_1.DATE_VALID).required(constants_1.DATE_REQUIRED),
    expiryDate: (0, yup_1.date)().label("Expiry date").required().typeError(constants_1.DATE_VALID).required(constants_1.DATE_REQUIRED),
    numberExercised: (0, yup_1.number)().label("Number exercised").required(),
    transactionids: (0, yup_1.array)().of((0, yup_1.string)()).label("Transaction IDs"),
});
//# sourceMappingURL=OptionUnit.js.map